import { Box, Container, Group, Text } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { HaiveLogo } from './HaiveLogo';

const CSS = `
  @keyframes float-slow {
    0%,100% { transform: translate(0,0) }
    33% { transform: translate(30px,-20px) }
    66% { transform: translate(-20px,15px) }
  }
`;

function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      py="md"
      mt={40}
      style={{ borderTop: '1px solid rgba(255,255,255,.05)' }}
    >
      <Container size={960} px="md">
        <Group justify="space-between" align="center" wrap="nowrap" gap="xs">
          <Group gap="sm" align="center" wrap="nowrap">
            <Box style={{ marginTop: 0 }}>
              <HaiveLogo h={20} variant="dimmed" showAlpha={false} />
            </Box>
            <Text size="xs" c="dimmed" style={{ opacity: 0.4, whiteSpace: 'nowrap' }}>
              Your AI. Your Rules.
            </Text>
          </Group>
          <Text size="xs" c="dimmed" style={{ opacity: 0.3 }}>&copy; {year} Haive</Text>
        </Group>
      </Container>
    </Box>
  );
}

export function AppLayout() {
  return (
    <Box style={{ minHeight: '100vh', background: '#0a0a0b', color: '#fff', display: 'flex', flexDirection: 'column' }}>
      <style>{CSS}</style>

      {/* ── Background Effects ── */}
      <Box style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden' }}>
        <Box
          style={{
            position: 'absolute', inset: 0,
            backgroundImage: `
              linear-gradient(rgba(253,126,20,.03) 1px, transparent 1px),
              linear-gradient(90deg, rgba(253,126,20,.03) 1px, transparent 1px)
            `,
            backgroundSize: '64px 64px',
            maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 20%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 20%, transparent 70%)',
          }}
        />
        <Box style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: '#fd7e14', filter: 'blur(150px)', opacity: 0.07, top: -300, right: -200, animation: 'float-slow 20s ease-in-out infinite' }} />
        <Box style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: '#1a365d', filter: 'blur(150px)', opacity: 0.09, bottom: -300, left: -200, animation: 'float-slow 25s ease-in-out infinite reverse' }} />
      </Box>

      <Box style={{ position: 'relative', zIndex: 1, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <AppHeader />
        <Box style={{ flex: 1 }}>
          <Outlet />
        </Box>
        <AppFooter />
      </Box>
    </Box>
  );
}
